// An army's table (role, unit and nickname, Move, zone, traits, what it gained), used on the league page,
// in the army builder and in a league game's room.
import React from 'react';
import type { LeaguePlayer } from '../../leagues/api';
import { currentSquad, choiceName } from '../../leagues/improvements';
import { TRAITS } from '../../games/capture-the-flag/units';
import type { UnitType } from '../../games/capture-the-flag/types';

// An army's units as they are now: role, name (nickname), kind, Move, traits, and what it gained.
export function ArmyTable({ player }: { player: LeaguePlayer }) {
  const squad = player.army ? currentSquad(player.army) : null;
  const units = player.army?.units ?? [];
  if (!squad) return <p className="site-muted">This army isn't visible yet.</p>;
  const gained = (i: number) => (player.army?.improvements ?? []).map((im, n) => ({ ...im, n })).filter(im => im.unit === i);
  return (
    <div role="table" aria-label={`${player.name}'s units`} style={{ display: 'grid', fontSize: 15 }}>
      <div role="row" style={{ display: 'grid', gridTemplateColumns: '80px minmax(0, 1.2fr) 48px 48px minmax(0, 1.4fr)', gap: 8, padding: '4px 8px', color: 'var(--muted)', fontSize: 11, fontWeight: 600, letterSpacing: '.08em', textTransform: 'uppercase' }}>
        <span role="columnheader">Role</span><span role="columnheader">Unit</span><span role="columnheader" style={{ textAlign: 'right' }}>Move</span><span role="columnheader" style={{ textAlign: 'right' }} title="Hexes in its guard zone">Zone</span><span role="columnheader">Traits</span>
      </div>
      {squad.map((u: UnitType, i) => {
        const g = gained(i);
        return (
          <div role="row" key={i} style={{ display: 'grid', gridTemplateColumns: '80px minmax(0, 1.2fr) 48px 48px minmax(0, 1.4fr)', gap: 8, alignItems: 'start', padding: '10px 8px', borderTop: '1px solid var(--panel-line)' }}>
            <span role="cell" className="site-kicker" style={{ paddingTop: 2 }}>{units[i]?.role ?? ''}</span>
            <span role="cell">{units[i]?.nick ? <><strong>{units[i].nick}</strong> <span className="site-muted">{units[i].type}</span></> : <strong>{units[i]?.type ?? u.name}</strong>}</span>
            <span role="cell" style={{ textAlign: 'right' }}>{u.move}</span>
            <span role="cell" style={{ textAlign: 'right' }}>{u.zone.length}</span>
            <span role="cell" style={{ fontSize: 14 }}>
              {u.traits.length ? u.traits.map(t => TRAITS[t].name).join(', ') : <span className="site-muted">None</span>}
              {g.length > 0 && <><br /><span style={{ color: 'var(--ok)', fontSize: 13 }}>Gained: {g.map(im => `${choiceName(im.choice)} (improvement ${im.n + 1})`).join(', ')}</span></>}
            </span>
          </div>
        );
      })}
    </div>
  );
}
